<div class="info-detail-widget">
  @if (!rawData()) {
    <div class="empty-state">
      <p class="empty-message">Nessun dato disponibile</p>
    </div>
  }

  @if (rawData()) {
    @for (section of sections; track section.title) {
      <div class="info-section">
        <h4 class="section-title">{{ section.title | translate }}</h4>
        <div class="section-items">
          @for (item of section.items; track item.field) {
            @if (shouldShowItem(item)) {
              <div class="section-item">
                <span class="item-label">{{ item.label | translate }}</span>
                <span
                  class="item-value"
                  [class.value-yes]="
                    getFieldValue(item.field) === 1 ||
                    getFieldValue(item.field) === true
                  "
                  [class.value-no]="
                    getFieldValue(item.field) === 0 ||
                    getFieldValue(item.field) === false
                  "
                >
                  {{ formatValue(getFieldValue(item.field), item.format) }}
                </span>
              </div>
            }
          }
        </div>
      </div>
    }
    @if (widget?.config?.hasConsensiSIAT) {
      <form [formGroup]="consensiForm">
        <div class="info-section">
          <h4 class="section-title">
            {{ 'CONSENSI.sectionSiat' | translate }}
          </h4>
          <span class="item-value">Modulo {{ modulo }}</span>
          <div class="section-item items-center!">
            <span id="consenso-fse-label" class="item-label">{{
              'CONSENSI.sectionFse' | translate
            }}</span>
            <siat-radio-field
              [formGroup]="consensiForm"
              controlName="fse"
              id="fse"
              name="fse"
              ariaLabelledBy="consenso-fse-label"
              [data]="consensiOptItems"
            >
            </siat-radio-field>
          </div>
          <div class="section-item items-center!">
            <span id="consenso-dse-label" class="item-label">{{
              'CONSENSI.sectionDse' | translate
            }}</span>
            <siat-radio-field
              [formGroup]="consensiForm"
              controlName="dse"
              id="dse"
              name="dse"
              ariaLabelledBy="consenso-dse-label"
              [data]="consensiOptItems"
            >
            </siat-radio-field>
          </div>
          <div class="section-item items-center!">
            <span id="consenso-maggior-tutela-label" class="item-label">{{
              'CONSENSI.sectionMaggiorTutela' | translate
            }}</span>
            <siat-radio-field
              [formGroup]="consensiForm"
              controlName="maggiorTutela"
              id="maggiorTutela"
              name="maggiorTutela"
              ariaLabelledBy="consenso-maggior-tutela-label"
              [data]="consensiOptItems"
            >
            </siat-radio-field>
          </div>
          <div class="flex justify-end mt-4">
            <span
              [matTooltip]="
                isApicActive || lockedPatient
                  ? 'Non è possibile eseguire l\'operazione in quanto il paziente è in trasferimento'
                  : ''
              "
            >
              <button
                matButton="filled"
                type="button"
                (click)="confirmSave()"
                [disabled]="isApicActive || lockedPatient"
              >
                {{ 'CRUD.actions.save' | translate: { item: 'consensi SIAT' } }}
              </button>
            </span>
          </div>
        </div>
      </form>
    }
  }
</div>
